import React, { Component, createRef, forwardRef, useImperativeHandle } from "react";
import { View, Image, TextInput, Text, FlatList, ActivityIndicator} from "react-native-web";
import { ParallaxProvider, ParallaxBanner, Parallax } from 'react-scroll-parallax';
import { AnimatePresence, motion, useScroll, useTransform, useMotionValue } from 'framer-motion';

import EmotionReactionsMobile from "../home/EmotionReactionsMobile";
import EmotionReactionsDisable from "../home/EmotionReactionsDisable";

import reactionStore from '../../../store/reactionStore';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import i18n from "../../../i18n";

import ReactionsInner from './ReactionsInner';


const algoliasearch = require('algoliasearch');
var client = algoliasearch('HKB157K3KU', '357f2b37e5ef8c12f7b90877758ff663');


const viewportWidth =  window.innerWidth;
const viewportHeight = window.innerHeight;

let titleFontSize30, titleFontSize25, titleFontSize22, titleFontSize20, titleFontSize19, titleFontSize18, titleFontSize17, titleFontSize16, titleFontSize15, titleFontSize14, titleFontSize13, titleFontSize;

if (viewportWidth > 1400)
{
   titleFontSize = 40;
   titleFontSize30 = 30;
   titleFontSize25 = 25;
   titleFontSize22 = 22;
   titleFontSize20 = 20;
   titleFontSize19 = 19;
   titleFontSize18 = 18;
   titleFontSize17 = 17;
   titleFontSize16 = 16;
   titleFontSize15 = 15;
   titleFontSize14 = 14;
   titleFontSize13 = 13;
}
else if (viewportWidth > 1200)
{
   titleFontSize = 35;
   titleFontSize30 = 26;
   titleFontSize25 = 22;
   titleFontSize22 = 20;
   titleFontSize20 = 19;
   titleFontSize19 = 18;
   titleFontSize18 = 17;
   titleFontSize17 = 16;
   titleFontSize16 = 15;
   titleFontSize15 = 14;
   titleFontSize14 = 13;
   titleFontSize13 = 12;
}
else
{
   titleFontSize = 30;
   titleFontSize30 = 24;
   titleFontSize25 = 19;
   titleFontSize22 = 17;
   titleFontSize20 = 18;
   titleFontSize19 = 17;
   titleFontSize18 = 16;
   titleFontSize17 = 15;
   titleFontSize16 = 14;
   titleFontSize15 = 13;
   titleFontSize14 = 12;
   titleFontSize13 = 11;
}




class PopReactions extends Component {
  constructor(props) {
    super(props);
    this.popupRef = createRef();


    let _user = null;
    if (props.sinUser !== null)
    {
       _user = JSON.parse(props.sinUser);
    }

    this.state = {
     updatedEmotion: null,
     reactions: this.props.selectedObject.reactions,
     user: _user,
     users: [],
     status: 'init',
     processing: false,
     showInnerDiv: false,
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);

    //this.loadUsers();
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }


  loadUsers() {

    var index = client.initIndex('Reaction');

    index
    .search('*',
    {
      page: 0,
      filters: `story_id:${this.props.selectedObject.objectID}`,
      hitsPerPage: 20
    })
    .then(({ hits, nbPages, page, nbHits }) =>
      {

            if (nbHits > 0)
            {

                  const multiplier = 20;

                  const expandedArray = hits.flatMap(obj =>
                    Array(multiplier).fill({ ...obj })
                  );

                 this.setState({
                   status: 'completed',
                   users: expandedArray //hits,
                 });

            }
            else
            {
                this.setState({
                  status: 'completed',
                  users: [],
                });
            }


     });
  }

  handleClickOutside = (event) => {
    if (this.popupRef.current && !this.popupRef.current.contains(event.target)) {
      this.closePopup(); // Call the function to close the popup
    }
  }

  closePopup() {
    this.setState({
      showInnerDiv: false
    });

    setTimeout(() => {
      this.props.onClose();
    }, 400);

  }

  displayInnerDiv() {
    this.setState({
      showInnerDiv: true
    });
  }


  handleOnReaction = (emotion) => {
    //alert(JSON.stringify(emotion));
     //onReactToMoment(emotion, item, index);
     this.onReactToMoment(emotion, this.props.selectedObject);
  }


  onReactToMoment = (emotion, item) => {

    if (emotion === null)
    {
          /*localStorage.setItem("storrypageAfter", `p/${this.state.object.public_id}?a=in`);
          setTimeout(() => {
            window.location = `/signin?after=p/${this.state.object.public_id}?a=in`;
          }, 200);*/
    }
    else
    {

          let _reactions = this.state.reactions;

          if (!_reactions.some(obj => obj.uid === this.state.user.uid))
          {
             let _obj = {uid: this.state.user.uid, key: emotion.key, emotion: emotion};
             _reactions.push(_obj);

             this.confirmReaction(item.objectID, 'new', emotion.key, {uid: this.state.user.uid, key: emotion.key, emotion: emotion}, _reactions);
          }
          else
          {


              if (_reactions.some(obj => obj.uid === this.state.user.uid && obj.key === emotion.key))
              {
                  const updatedReactions = _reactions.filter(obj => obj.uid !== this.state.user.uid);

                  _reactions = updatedReactions;

                  this.confirmReaction(item.objectID, 'remove', emotion.key, {uid: this.state.user.uid, key: emotion.key, emotion: emotion}, _reactions);
              }
              else
              {
                  let updatedReactions = _reactions.filter(obj => obj.uid !== this.state.user.uid);

                  let _obj = {uid: this.state.user.uid, key: emotion.key, emotion: emotion};
                  updatedReactions.push(_obj);

                  _reactions = updatedReactions;

                  this.confirmReaction(item.objectID, 'switch', emotion.key, {uid: this.state.user.uid, key: emotion.key, emotion: emotion}, _reactions);
              }
          }


        /*  this.setState({
            reactions: [..._reactions]
          }); */


          /*

          const items = [...this.state.items];
          const updatedArray = items.map(obj =>
             obj.objectID === item.objectID ?
             { ...obj,
               reactions: _reactions
               } : obj
          );


          this.setState({
            items: updatedArray
          }); */

    }

}



  confirmReaction(id, typef, key, emotion, reactions) {

    var ip = 'https://api1.debyoo.com/';

    var jwtToken = this.state.user.jwt_token;


    let hash = {
      auth_check: 'jwt',
      id: id,
      typef: typef,
      k: key,
      em: JSON.stringify(emotion)
    };


    fetch(ip+'confirm_storrypage_reaction_api', {
           method: 'POST',
           headers: {
             'Accept': 'application/json',
             'Authorization': jwtToken,
             'Content-Type': 'application/json'
           },
           credentials: 'include',
           body: JSON.stringify(hash)
        })
      .then((response) => response.json())
      .then((responseData) => {

                   client.clearCache();

                   const newReactions = [...reactions];

                   this.setState({
                     reactions: newReactions,
                     updatedEmotion: {id: responseData.id, typef: responseData.typef, category: responseData.category}
                   });

                   reactionStore.getState().setSelectedItems({objectID: id, reactions: reactions});

                   setTimeout(() => {
                     reactionStore.getState().triggerHandler();
                   }, 100);

                   /*setTimeout(() => {
                     this.setState({
                       reactions: [...reactions]
                     });
                   }, 5000);*/

       })
       .catch(function(error) {

       }.bind(this));
  }









  render() {
    return (
      <div style={{position: 'fixed', zIndex: 99, width: '100%', height: '100%', top: 0, left: 0, bottom: 0, display: 'flex',
                               alignItems: 'center',backgroundColor: 'rgba(0,0,0,0.1)'}}>

            {isMobileOnly &&
              <div className="scroll-area"
                     style={{
                       width: '100%',
                       maxHeight: "100vh",
                       overflowY: "hidden",
                       position: "relative",
                       zIndex: 0,
                     }}
                   >

               <div style={{width: '100%', minHeight: viewportHeight+'px', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', overflow: 'hidden'}}>

                    <AnimatePresence>

                        {this.state.showInnerDiv && (

                            <motion.div ref={this.popupRef}
                                     initial={{ x: "100%", opacity: 0 }}
                                    animate={{ x: "0%", opacity: 1 }}
                                    exit={{ x: "100%", opacity: 0 }}
                                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                                   style={{position: 'relative', width: '100%',
                                         height: viewportHeight*1.1+'px', overflow: 'auto',
                                         marginTop: '0px', marginBottom: '40px',
                                         backgroundColor: 'white',
                                         boxShadow: "-2px 0 8px rgba(0,0,0,0.1)"}}>

                                         <div style={{position: 'fixed', zIndex: 3, top: 0, width: '100%', height: '50px', backgroundColor: '#fff'}}>
                                             <div style={{width: '94%', height: '50px', margin: 'auto', marginTop:  '5px'}}>
                                                 <div style={{width: '100%', margin: 'auto', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                                    <div>
                                                        <View style={{display: 'none', height: '50px', justifyContent: 'center'}}>
                                                           {this.state.reactions.length === 0 && <Text style={{color: '#333', fontSize: titleFontSize20+'px', fontWeight: 'bold'}}>{i18n.t('Reactions')}</Text>}
                                                           {this.state.reactions.length === 1 && <Text style={{color: '#333', fontSize: titleFontSize20+'px', fontWeight: 'bold'}}>{this.state.reactions.length} {i18n.t('Reaction')}</Text>}
                                                           {this.state.reactions.length > 1 && <Text style={{color: '#333', fontSize: titleFontSize20+'px', fontWeight: 'bold'}}>{this.state.reactions.length} {i18n.t('Reactions')}</Text>}
                                                        </View>
                                                    </div>




                                                      <div onClick={this.closePopup.bind(this)}>
                                                          <View style={{height: '50px', justifyContent: 'center'}}>
                                                             <Image source={{uri: '/img/cancel_icon_grey.png'}} style={{width: '30px', height: '30px'}}/>
                                                          </View>
                                                      </div>


                                                 </div>
                                             </div>
                                         </div>




                                         {!this.props.selectedObject.reactions_are_on &&
                                           <div style={{position: 'fixed', zIndex: 3, top: 5, left: 5, width: '90%', display: 'flex', height: '42px', flexDirection: 'row'}}>
                                              <div style={{height: '42px',}}>
                                                <EmotionReactionsDisable />
                                              </div>

                                              <div style={{marginLeft: '10px', height: '42px'}}>
                                                  <View style={{height: '38px', justifyContent: 'center'}}>
                                                     <Text numberOfLines={2} style={{color: '#111', fontSize: titleFontSize17+'px'}}>{i18n.t('Reactions_are_off')}</Text>
                                                  </View>
                                              </div>
                                           </div>
                                         }


                                         {this.props.selectedObject.reactions_are_on &&
                                           <div style={{position: 'fixed', zIndex: 99, top: 5, left: 5, width: '80%', display: 'flex', flexDirection: 'row'}}>
                                              <div style={{}}>
                                                <EmotionReactionsMobile onReact={this.handleOnReaction} item={this.props.selectedObject} user={this.state.user} />
                                              </div>

                                              <div style={{marginLeft: '5px', height: '42px'}}>
                                                  <View style={{height: '38px', justifyContent: 'center'}}>
                                                     {this.state.reactions.length === 0 && <Text numberOfLines={2} style={{color: '#111', fontSize: titleFontSize15+'px'}}>{i18n.t('Be_the_first_to_react')}</Text>}
                                                     {this.state.reactions.length === 1 && (this.state.user === null || (this.state.user !== null && !this.state.reactions.some(obj => obj.uid ===this.state.user.uid))) &&
                                                          <Text numberOfLines={2} style={{color: '#111', fontSize: titleFontSize15+'px'}}>{i18n.t('One_person_has_reacted')}</Text>
                                                     }
                                                     {this.state.reactions.length === 1 && this.state.user !== null && this.state.reactions.some(obj => obj.uid === this.state.user.uid) &&
                                                          <Text numberOfLines={2} style={{color: '#111', fontSize: titleFontSize15+'px'}}>{i18n.t('You_are_the_first_to_react')}</Text>
                                                     }
                                                     {this.state.reactions.length === 2 && this.state.user !== null && this.state.reactions.some(obj => obj.uid === this.state.user.uid) &&
                                                          <Text numberOfLines={2} style={{color: '#111', fontSize: titleFontSize15+'px'}}>{i18n.t('You_and_one_other_person_have_reacted')}</Text>
                                                     }
                                                     {this.state.reactions.length > 2 && this.state.user !== null && this.state.reactions.some(obj => obj.uid === this.state.user.uid) &&
                                                          <Text numberOfLines={2} style={{color: '#111', fontSize: titleFontSize15+'px'}}>{i18n.t('You_and')} {this.state.reactions.length-1} {i18n.t('other_persons_have_reacted')}</Text>
                                                     }
                                                     {this.state.reactions.length > 1 && (this.state.user === null || (this.state.user !== null && !this.state.reactions.some(obj => obj.uid === this.state.user.uid))) &&
                                                          <Text  numberOfLines={2} style={{color: '#111', fontSize: titleFontSize15+'px'}}>{this.state.reactions.length} {i18n.t('persons_have_reacted')}</Text>
                                                     }
                                                  </View>
                                              </div>


                                           </div>
                                         }


                                         <div style={{width: '100%'}}>



                                               <div style={{width: '100%', marginTop: '85px' }}>

                                                   <ReactionsInner moment_id={this.props.selectedObject.objectID} updatedEmotion={this.state.updatedEmotion} reactions={this.state.reactions} width={viewportWidth} height={viewportHeight-50}/>
                                               </div>

                                         </div>





                             </motion.div>
                         )}

                     </AnimatePresence>

                  </div>

              </div>
            }



            {!isMobileOnly &&
              <div className="scroll-area"
                     style={{
                       width: '100%',
                       maxHeight: "100vh",
                       overflowY: "hidden",
                       position: "relative",
                       zIndex: 0,
                     }}
                   >

               <div style={{width: '100%', minHeight: viewportHeight+'px', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', overflow: 'hidden'}}>

                    <AnimatePresence>

                        {this.state.showInnerDiv && (

                            <motion.div ref={this.popupRef}
                                     initial={{ x: "100%", opacity: 0 }}
                                    animate={{ x: "0%", opacity: 1 }}
                                    exit={{ x: "100%", opacity: 0 }}
                                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                                   style={{position: 'relative', width: '540px', display: 'flex', alignSelf: 'flex-end',
                                         height: isTablet ? (viewportHeight+40)+'px':viewportHeight+'px', overflow: 'auto',
                                         marginTop: '0px', marginBottom: '0px',
                                         backgroundColor: 'white',
                                         boxShadow: "-2px 0 8px rgba(0,0,0,0.1)"}}>


                                         <div style={{position: 'fixed', zIndex: 99, top: 0, right: 0, width: '540px', height: '50px', backgroundColor: '#fff'}}>
                                             <div style={{width: '520px', height: '50px', margin: 'auto', marginTop:  '5px'}}>
                                                 <div style={{width: '100%', margin: 'auto', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                                    <div>
                                                        <View style={{height: '50px', justifyContent: 'center'}}>
                                                           {this.state.reactions.length === 0 && <Text style={{color: '#333', fontSize: titleFontSize20+'px', fontWeight: 'bold'}}>{i18n.t('Reactions')}</Text>}
                                                           {this.state.reactions.length === 1 && <Text style={{color: '#333', fontSize: titleFontSize20+'px', fontWeight: 'bold'}}>{this.state.reactions.length} {i18n.t('Reaction')}</Text>}
                                                           {this.state.reactions.length > 1 && <Text style={{color: '#333', fontSize: titleFontSize20+'px', fontWeight: 'bold'}}>{this.state.reactions.length} {i18n.t('Reactions')}</Text>}
                                                        </View>
                                                    </div>




                                                      <div onClick={this.closePopup.bind(this)}>
                                                          <View style={{height: '50px', justifyContent: 'center'}}>
                                                             <Image source={{uri: '/img/cancel_icon_grey.png'}} style={{width: '30px', height: '30px'}}/>
                                                          </View>
                                                      </div>


                                                 </div>
                                             </div>
                                         </div>


                                         <div style={{width: '100%'}}>
                                             <div style={{width: '540px',  marginTop: '0px' }}>
                                                 <ReactionsInner moment_id={this.props.selectedObject.objectID} updatedEmotion={this.state.updatedEmotion} reactions={this.state.reactions} width={540} height={viewportHeight-50}/>
                                             </div>
                                         </div>




                             </motion.div>
                         )}

                     </AnimatePresence>

                  </div>

              </div>
            }

       </div>
    );
  }
}

export default PopReactions;
